import Head from 'next/head';
import flagsmith from 'flagsmith/isomorphic';
import { useTranslation } from '@features/i18n/infra/useTranslation';
import { AuthLayout } from 'components/layout';
import { useNameComponent } from 'hooks';
import Register from '../features/auth/ui/Register/Register';
import UnifiedRegister from '../features/auth/ui/Register/UnifiedRegister';
import CarouselLayout from '../features/auth/ui/common/carousel/CarouselLayout';

function RegisterPage() {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <Head>
        <title>{t('REGISTER_SEO_META_TITLE')}</title>
        <meta name="description" content={t('REGISTER_SEO_META_DESCRIPTION')} />
      </Head>

      <CarouselLayout
        isMobileCarouselEnabled={flagsmith.hasFeature(
          'saas_enable_onboarding_mobile_carousel'
        )}
      >
        {flagsmith.hasFeature('saas_register_full_register') ? (
          // eslint-disable-next-line react-hooks/rules-of-hooks
          <UnifiedRegister dataCy={useNameComponent('full-register')} />
        ) : (
          // eslint-disable-next-line react-hooks/rules-of-hooks
          <Register dataCy={useNameComponent('register')} />
        )}
      </CarouselLayout>
    </AuthLayout>
  );
}

export default RegisterPage;
